import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapLocationDot,
  faPhone,
  faShieldHalved,
  faFireExtinguisher,
  faCarOn,
  faEnvelope,
  faHospital,
  faStethoscope,
  faWrench,
  faBuildingColumns,
  faClinicMedical,
} from "@fortawesome/free-solid-svg-icons";

const iconos = {
  policia: faShieldHalved,
  bomberos: faFireExtinguisher,
  transito: faCarOn,
  correo: faEnvelope,
  salud: faStethoscope,
  gomeria: faWrench,
  banco: faBuildingColumns,
  hospital: faHospital,
  clinica: faClinicMedical,
};

const serviciosCol1 = [
  {
    nombre: "Policia",
    link: "https://maps.app.goo.gl/AoUvZbrcn49GcMZSA",
    direccion: (
      <>
        Caseros 202.<br />
        <FontAwesomeIcon icon={faPhone} style={{fontSize:"14px"}}/> 101<br />
        <FontAwesomeIcon icon={faPhone} style={{fontSize:"14px"}}/> 03532 - 428940<br />
      </>
    ),
  },
  {
    nombre: "Bomberos Voluntarios",
    link: "https://maps.app.goo.gl/Vc5nwupNkiWoWd3i7",
    direccion: (
      <>
        Caseros.<br />
        <FontAwesomeIcon icon={faPhone} style={{fontSize:"14px"}}/> 100<br />
        <FontAwesomeIcon icon={faPhone} style={{fontSize:"14px"}}/> 03532 - 420019
      </>
    ),
  },
  {
    nombre: "Transito y Seguridad Ciudadana",
    link: "https://maps.app.goo.gl/ydsngWuMEycq5aF66",
    direccion: (
      <>
        Belgrano 292.<br />
        <FontAwesomeIcon icon={faPhone} style={{fontSize:"14px"}}/> 03532 - 410100<br />
       <FontAwesomeIcon icon={faPhone} style={{fontSize:"14px"}}/> 03532 - 15447893
      </>
    ),
  },
  {
    nombre: "Correo Argentino",
    link: "https://maps.app.goo.gl/Bzea3bRt2EmqeZPq5",
    direccion: (
      <>
        Belgrano 297.<br />
      </>
    ),
  },
];

const centrosSalud = [
  {
    nombre: "Centro de Salud Nº1 “José Accosatto”",
    link: "https://maps.app.goo.gl/sLLZF19aaBoHAjT87",
    direccion: (
      <>
        Blvd. Dr. R.Moyano Esquina Francia<br />
        <FontAwesomeIcon icon={faPhone} style={{fontSize:"14px"}}/> 03532 - 411195
      </>
    ),
  },
  {
    nombre: "Centro de Salud Nº2 “Medalla Milagrosa”",
    link: "https://maps.app.goo.gl/gQhYPpXTi8qTrKgV8",
    direccion: (
      <>
        Sarmiento 1400<br />
        <FontAwesomeIcon icon={faPhone} style={{fontSize:"14px"}}/> 03532 - 411510
      </>
    ),
  },
  {
    nombre: "Centro de Salud Nº3 “San Cayetano”",
    link: "https://maps.app.goo.gl/gQhYPpXTi8qTrKgV8",
    direccion: (
      <>
        25 de mayo 353<br />
        <FontAwesomeIcon icon={faPhone} style={{fontSize:"14px"}}/> 03532 - 413528
      </>
    ),
  },
];

const gomerias = [
  {
    nombre: "Gomería La Esquina",
    link: "https://maps.app.goo.gl/nmhDtDcPixFjGEKw5",
    direccion: (
      <>
        Esquina Italia & Mendoza.<br />
        <FontAwesomeIcon icon={faPhone} style={{fontSize:"14px"}}/> 03532 - 15436036
      </>
    ),
  },
  {
    nombre: "Gomería Jerusalén",
    link: "https://maps.app.goo.gl/WQg46DAoeH2irWXu7",
    direccion: (
      <>
        Leandro N. Alem 1239<br />
        <FontAwesomeIcon icon={faPhone} style={{fontSize:"14px"}}/> 03532 - 15439171
      </>
    ),
  },
  {
    nombre: "Gomería Candellero",
    link: "https://maps.app.goo.gl/qAKaVVFkUUdzYEMRA",
    direccion: (
      <>
        Leandro N. Alem & Suipacha<br />
        <FontAwesomeIcon icon={faPhone} style={{fontSize:"14px"}}/> 03532 - 15416603
      </>
    ),
  },
  {
    nombre: "Gomería Tio Felipe",
    link: "https://maps.app.goo.gl/wXRzcfNBCXqJ4DQp7",
    direccion: (
      <>
        Roque Sáenz Peña & 25 de Mayo<br />
        <FontAwesomeIcon icon={faPhone} style={{fontSize:"14px"}}/> 03532 - 15499334
      </>
    ),
  },
];

const serviciosCol2 = [
  {
    nombre: "Banco Nación",
    link: "https://maps.app.goo.gl/Yng6ByvETRAfNNVt5",
    direccion: (
      <>
        Sarmiento 194 – Esquina Caseros.<br />
      </>
    ),
  },
  {
    nombre: "Bancor – Banco Córdoba",
    link: "https://maps.app.goo.gl/4zjoghYX54a1Rxho9",
    direccion: (
      <>
        Pueyrredón 169.<br />
      </>
    ),
  },
  {
    nombre: "Banco Macro",
    link: "https://maps.app.goo.gl/PsZn5KrED7bVK6qY8",
    direccion: (
      <>
        Av. Olmos – Esquina Sarmiento.
      </>
    ),
  },
];

const hospitales = [
  {
    nombre: "Hospital Zonal",
    link: "https://maps.app.goo.gl/hTVZoFhQQnQaJdhZ7",
    direccion: (
      <>
        Hipólito Yrigoyen 500 – Esquina Monseñor Gallardo.<br />
        <FontAwesomeIcon icon={faPhone} style={{fontSize:"14px"}}/> 03532 - 411111
      </>
    ),
  },
  {
    nombre: "Centro médico modelo",
    link: "https://maps.app.goo.gl/fFDZSt6dDGZRF8PK7",
    direccion: (
      <>
        Bartolomé mitre 161.<br />
        <FontAwesomeIcon icon={faPhone} style={{fontSize:"14px"}}/> 03532 - 410365<br />
        <FontAwesomeIcon icon={faPhone} style={{fontSize:"14px"}}/> 03532 - 15415808
      </>
    ),
  },
  {
    nombre: "Clínica Privada San José",
    link: "https://maps.app.goo.gl/9Y97ht342zXeHvoW8",
    direccion: (
      <>
        Bartolomé mitre 150.<br />
        <FontAwesomeIcon icon={faPhone} style={{fontSize:"14px"}}/> 03532 - 420545<br />
      </>
    ),
  },
  {
    nombre: "Centro médico de Especialidades",
    link: "https://maps.app.goo.gl/j8Jsu8boiZApmu2x5",
    direccion: (
      <>
        Bartolomé mitre 145.<br />
        <FontAwesomeIcon icon={faPhone} style={{fontSize:"14px"}}/> 03532 - 420519<br />
      </>
    ),
  },
  {
    nombre: "Casona Salud",
    link: "https://maps.app.goo.gl/bN8dfAvYrZBonHNW7",
    direccion: (
      <>
        San Martín 134.<br />
        <FontAwesomeIcon icon={faPhone} style={{fontSize:"14px"}}/> 03532 - 411538<br />
      </>
    ),
  },
  {
    nombre: "Medicina Cardio Integral",
    link: "https://maps.app.goo.gl/CjJqXuL38v1YNHbB6",
    direccion: (
      <>
        Bartolomé Mitre 452.<br />
        <FontAwesomeIcon icon={faPhone} style={{fontSize:"14px"}}/> 03532 - 15679154<br />
      </>
    ),
  },
  {
    nombre: "Centro Diagnostico Oliva",
    link: "https://maps.app.goo.gl/4f1FQrzsSns6H6f4A",
    direccion: (
      <>
        9 de Julio 530.<br />
        <FontAwesomeIcon icon={faPhone} style={{fontSize:"14px"}}/> 03532 - 413553<br />
      </>
    ),
  },
  {
    nombre: "Instituto Médico Oliva",
    link: "https://maps.app.goo.gl/95hiU3CJGVEYRuUC7",
    direccion: (
      <>
        Esquina Casero y Bartolomé Mitre.<br />
        <FontAwesomeIcon icon={faPhone} style={{fontSize:"14px"}}/> 03532 - 15510994<br />
      </>
    ),
  },
];

const Servicios = () => (
  <div className="content-tab">
    <div className="row">
      <div className="col-12 col-md-6">
        <h5>
          <FontAwesomeIcon icon={iconos.policia} style={{ color: "#2d98da", marginRight: 8 }} />
          Servicios de Emergencia
        </h5>
        <ul className="lista-referencias">
          {serviciosCol1.map((serv, i) => (
            <li key={i}>
              <FontAwesomeIcon icon={faMapLocationDot} style={{ marginRight: 8 }} />
              <a href={serv.link} target="_blank" rel="noopener noreferrer">
                {serv.nombre}
              </a>
              <div className="ms-2 me-auto">{serv.direccion}</div>
            </li>
          ))}
        </ul>
        <br />
        <h5>
          <FontAwesomeIcon icon={iconos.salud} style={{ color: "#27ae60", marginRight: 8 }} />
          Centros de Salud
        </h5>
        <ul className="lista-referencias">
          {centrosSalud.map((salud, i) => (
            <li key={i}>
              <FontAwesomeIcon icon={faMapLocationDot} style={{ marginRight: 8 }} />
              <a href={salud.link} target="_blank" rel="noopener noreferrer">
                {salud.nombre}
              </a>
              <div className="ms-2 me-auto">{salud.direccion}</div>
            </li>
          ))}
        </ul>
        <h5>
          <FontAwesomeIcon icon={iconos.gomeria} style={{ color: "#e67e22", marginRight: 8 }} />
          Gomerías
        </h5>
        <ul className="lista-referencias">
          {gomerias.map((gom, i) => (
            <li key={i}>
              <FontAwesomeIcon icon={faMapLocationDot} style={{ marginRight: 8 }} />
              <a href={gom.link} target="_blank" rel="noopener noreferrer">
                {gom.nombre}
              </a>
              <div className="ms-2 me-auto">{gom.direccion}</div>
            </li>
          ))}
        </ul>
      </div>
      <div className="col-12 col-md-6">
        <h5>
          <FontAwesomeIcon icon={iconos.banco} style={{ color: "#34495e", marginRight: 8 }} />
          Bancos
        </h5>
        <ul className="lista-referencias">
          {serviciosCol2.map((serv, i) => (
            <li key={i}>
              <FontAwesomeIcon icon={faMapLocationDot} style={{ marginRight: 8 }} />
              <a href={serv.link} target="_blank" rel="noopener noreferrer">
                {serv.nombre}
              </a>
              <div className="ms-2 me-auto">{serv.direccion}</div>
            </li>
          ))}
        </ul>
        <br />
        <h5>
          <FontAwesomeIcon icon={iconos.hospital} style={{ color: "#c0392b", marginRight: 8 }} />
          Hospitales y Clínicas Privadas
        </h5>
        <ul className="lista-referencias">
          {hospitales.map((hos, i) => (
            <li key={i}>
              <FontAwesomeIcon icon={faMapLocationDot} style={{ marginRight: 8 }} />
              <a href={hos.link} target="_blank" rel="noopener noreferrer">
                {hos.nombre}
              </a>
              <div className="ms-2 me-auto">{hos.direccion}</div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

export default Servicios;